// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2eddB","title":"ClientReferral_title__3t69S","itemText":"ClientReferral_itemText__3occ-"};